import * as React from 'react'

import { GlobalWaitListSignUpWidget } from '@thg-commerce/enterprise-network/src/generated/graphql'
import {
  WaitlistSignup,
  WaitlistSignupProps,
} from '@thg-commerce/enterprise-widget-waitlist-signup'

import { BaseWidgetProps } from '../types'

export type WaitlistSignupWidgetRendererProps = BaseWidgetProps &
  Omit<
    GlobalWaitListSignUpWidget,
    | 'id'
    | 'query'
    | 'errorReturnUrl'
    | 'noAccountReturnUrl'
    | 'registeredReturnUrl'
    | 'enableNameField'
    | 'enableSignUp'
    | 'signUpText'
  >

export const WaitlistSignupWidgetRenderer = (
  props: WaitlistSignupWidgetRendererProps,
) => {
  if (!props || !props.campaignCode) {
    return null
  }

  const waitlistSignupWidgetProps: WaitlistSignupProps = {
    title: {
      text: props.title || undefined,
    },
    subtitle: {
      text: props.subtitle || undefined,
    },
    buttonText: props.buttonText || undefined,
    campaignCode: props.campaignCode,
    gdprDisclaimerText: props.gdprDisclaimerText || undefined,
    emailPlaceholderText: props.placeholderText || undefined,
    fullNamePlaceholderText: props.fullNamePlaceholderText || undefined,
  }
  return <WaitlistSignup {...waitlistSignupWidgetProps} />
}
